import { useState, useEffect } from "react";
import axios from "../../api/axios";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import Select from "react-select";

export default function CreateOrEditPage() {
    const { pageId } = useParams();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        label: "",
        path: "",
        icon: "",
        parent_id: "",
        order: 0,
        show_in_menu: true
    });

    const [pages, setPages] = useState([]);

    useEffect(() => {
        axios.get("/roles/pages").then(res => {
            const pageOption = res.data?.map((item) => {
                return { value: item.id, label: item.label };
            });
            setPages(pageOption)
            });
        if (pageId) {
            axios.get(`/roles/pages/${pageId}`).then(res => {
                setFormData({
                    ...res.data,
                    parent_id: res.data.parent_id || ""
                });
            });
        }
    }, [pageId]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (pageId) {
                await axios.put(`/roles/pages/${pageId}`, formData);
                toast.success('Page updated successfully')
            } else {
                await axios.post("/roles/pages", formData);
                toast.success('Page created successfully')
            }
            navigate("/page-list");
        } catch (error) {
            console.error(error);
            toast.error('Failed to submit page')
        }
    };

    return (
        <div className="mx-auto p-4 bg-white rounded-xl shadow">
            <h2 className="text-xl font-semibold mb-4">{pageId ? "Edit Page" : "Create New Page"}</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                    <div>
                        <label className="block mb-1 font-medium">Label</label>
                        <input
                            type="text"
                            name="label"
                            placeholder="Enter Label"
                            value={formData.label}
                            onChange={handleChange}
                            className="w-full border rounded px-3 py-2"
                            required
                        />
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">Path</label>
                        <input
                            type="text"
                            name="path"
                            placeholder="Enter path"
                            value={formData.path}
                            onChange={handleChange}
                            className="w-full border rounded px-3 py-2"
                            
                        />
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">Icon</label>
                        <input
                            type="text"
                            name="icon"
                            placeholder="Enter icon"
                            value={formData.icon}
                            onChange={handleChange}
                            className="w-full border rounded px-3 py-2"
                        />
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">Parent Page</label>
                        <Select
                            name="parent_id"
                            onChange={e => setFormData(f => ({ ...formData, parent_id: e.value }))}
                            value={pages.filter((v)=> v.value === formData.parent_id)}
                            options={pages}
                            placeholder="Select Category"
                            className="w-full"
                            classNamePrefix="react-select"
                            maxMenuHeight={150}
                        />
                    </div>

                    <div>
                        <label className="block mb-1 font-medium">Order</label>
                        <input
                            type="number"
                            name="order"
                            placeholder="Enter order"
                            value={formData.order}
                            onChange={handleChange}
                            className="w-full border rounded px-3 py-2"
                        />
                    </div>

                    <div className="flex justify-start items-center mt-4">
                        <input
                            type="checkbox"
                            name="show_in_menu"
                            checked={formData.show_in_menu}
                            onChange={handleChange}
                            className="mr-2 w-auto"
                        />
                        <label className="font-medium">Show in Menu</label>
                    </div>

                    <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
                        {pageId ? "Update Page" : "Create Page"}
                    </button>
                </div>
            </form>
        </div>
    );
}
